export const shuffleArray = (array) => {
  let currentIndex = array.length, randomIndex;
  while (currentIndex > 0) {
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;
    [array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]];
  }
  return array;
};

export const sortAlphabeticallyByProperty = (items, property) => { 
  const getValue = (item) => {
    if (Array.isArray(property)) return property.reduce((obj, key) => (obj && obj[key] !== undefined ? obj[key] : ''), item);
    return item[property] ?? '';
  };
  return items.sort((a, b) => {
    const valA = getValue(a).toString().toLowerCase();
    const valB = getValue(b).toString().toLowerCase();
    return valA.localeCompare(valB);
  });
};

export const sortChronologicallyByProperty = (items, property, reverse = false) => {
  return items.sort((a, b) => {
    const dateA = new Date(a[property]);
    const dateB = new Date(b[property]);
    if (isNaN(dateA) || isNaN(dateB)) return 0;
    return reverse ? dateB - dateA : dateA - dateB;
  });
};

export const sortDatesChronologically = (dates, reverse = false) => {
  return [...dates].sort((a, b) =>
    reverse ? new Date(b) - new Date(a) : new Date(a) - new Date(b)
  );
};